export const recaptchaSetup = () => {
  return `
    const userConfig = {
      apiKeys: {
        recaptcha: '${process.env.GATSBY_GOOGLE_RECAPTCHA_KEY}'
      },
      fields: {
        recaptchaFinger: 'reCAPTCHALastUserFingerprint',
      },
      actions: {
        formSubmit: 'form'
      },
      debug: {
        testBadFinger: false
      }
    };

    var recaptchaListeners = {
      ready: function () {
        MktoForms2.whenReady(function (mktoForm) {
          var formEl = mktoForm.getFormElem()[0],
            submitButtonEl = formEl.querySelector("button[type=\'submit\']");

          submitButtonEl.disabled = false;
        });
      }
    };
    Object.keys(recaptchaListeners).forEach(function globalize(fnName) {
      window['grecaptchaListeners_' + fnName] = recaptchaListeners[fnName];
    });

    /* inject the reCAPTCHA library */
    recaptchaLib = document.createElement('script');
    recaptchaLib.src = 'https://www.google.com/recaptcha/api.js?render=' + userConfig.apiKeys.recaptcha + '&onload=grecaptchaListeners_ready';
    document.head.appendChild(recaptchaLib);
`;
};
